export default {
  id: 'vitalSign/BODY_HEIGHT/v1',
  formSchema: {
    title: 'encounter:widget.vitalSigns.bodyHeight',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'number',
        minimum: 1,
        maximum: 999,
        title: 'encounter:widget.vitalSigns.bodyHeight'
      }
    },
    iconClass: 'icon-arrow-up',
    measurement: 'cm'
  },
  uiSchema: {
    id001: { 'ui:widget': 'customI18nNumericWidget' },
    'x-customClass': 'vital-signs-widget',
    'x-cancelBtnSize': 'sm',
    'x-saveBtnSize': 'sm'
  }
};
